import React from "react";

const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse rounded-md bg-ink-100 dark:bg-ink-800 ${className}`} />
);

export const TableSkeleton = ({ rows = 5, cols = 4 }) => (
  <div className="space-y-3 p-5">
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex gap-4">
        {Array.from({ length: cols }).map((__, c) => (
          <Skeleton key={c} className="h-4 flex-1" />
        ))}
      </div>
    ))}
  </div>
);

export default Skeleton;
